export const TEAM = [
  {
    name: "Toriano Sanzone",
    role: "Co-Founder",
    image: "https://img1.wsimg.com/isteam/ip/f7fe6576-a77b-4d71-b5e1-10dac05c50f3/6S2A6859.jpeg/:/rs=w:800,cg:true",
    lead: "A North Lawndale community pillar with roots extending 85 years in the neighborhood.",
    bio: [
      "Toriano Sanzone's profound commitment to service is a family legacy, with multiple generations serving in the U.S. military.",
      "This deep personal connection fuels his mission as Co-Founder of the Golden Wolf Foundation, where he channels a lifetime of respect and gratitude into actionable support for United States Veterans — giving back to those who have given so much.",
    ],
    tags: ["Founder", "North Lawndale", "Veteran Family Legacy"],
    featured: true,
  },
  {
    name: "Rozanna Rivera",
    role: "Co-Founder",
    image: "https://img1.wsimg.com/isteam/ip/f7fe6576-a77b-4d71-b5e1-10dac05c50f3/rozie1.jpeg/:/rs=w:800,cg:true",
    lead: "Driven by an exceptional and unwavering commitment to serving Veterans in Chicago.",
    bio: [
      "Rozanna Rivera is a passionate Co-Founder of the Golden Wolf Foundation. Her advocacy is the bedrock of our mission, translating deep compassion into actionable support.",
      "As the cornerstone of our sustainability and growth, Ms. Rivera specializes in strategic fundraising and the meticulous craft of grant writing, building the financial foundations that allow every service dog to find its hero.",
    ],
    tags: ["Founder", "Fundraising", "Grant Writing"],
  },
  {
    name: "Greg Richard",
    role: "Co-Founder",
    image: "https://img1.wsimg.com/isteam/ip/f7fe6576-a77b-4d71-b5e1-10dac05c50f3/blob-0004.png/:/rs=w:800,cg:true",
    lead: "30 years of finance and business development expertise.",
    bio: [
      "Greg Richard brings three decades of finance and business development expertise to the Golden Wolf Foundation, complementing 25 years of joint experience with Toriano Sanzone managing dog training companies.",
      "His commitment is personal and local: his wife, Francine, is a U.S. Veteran, and his family has been proud residents of North Lawndale for the past decade.",
    ],
    tags: ["Founder", "Finance", "Business Development"],
  },
  {
    name: "Tyrone Scott",
    role: "Lead Trainer",
    image: "https://img1.wsimg.com/isteam/ip/f7fe6576-a77b-4d71-b5e1-10dac05c50f3/Tyrone.jpg/:/rs=w:800,cg:true",
    lead: "25 years of dedicated dog training experience rooted in North Lawndale.",
    bio: [
      "Tyrone Scott serves as the Lead Trainer for the Golden Wolf Foundation, bringing 25 years of dog training experience to the mission.",
      "His expertise is specifically focused on serving Veterans — beginning his work with this community in 2010 and specializing exclusively in service dog training for the past 16 years. This deep, specialized experience ensures every trained dog provides transformative support.",
    ],
    tags: ["Lead Trainer", "Service Dogs", "16+ Years"],
  },
  {
    name: "Heather Beck",
    role: "Assistant Lead Trainer · Director of Veteran Relations",
    image: "https://img1.wsimg.com/isteam/ip/f7fe6576-a77b-4d71-b5e1-10dac05c50f3/Golden%20Wolf%20Foundation%20V2-01.png/:/rs=w:800,cg:true",
    lead: "A U.S. Veteran and professional dog trainer serving the community she's proud to be part of.",
    bio: [
      "Heather Beck is a U.S. Veteran and professional dog trainer, bringing a profound personal and professional understanding to her dual role at the Golden Wolf Foundation.",
      "As Assistant Lead Trainer she applies her expert skills to our service dog program, and as Director of Veteran Relations she ensures our services stay veteran-centered — leveraging her firsthand experience to support fellow veterans.",
    ],
    tags: ["U.S. Veteran", "Trainer", "Veteran Relations"],
  },
];
